/**
 * CihSectionHeader — small eyebrow label stacked above a section title.
 * Used at the top of every major section on CIH detail pages.
 *
 * Distinct from the existing `CihSectionHeading` component (which is a simple
 * centered heading with eyebrow) — the two coexist.
 *
 * Aliases: section header, section kicker
 */

type CihSectionHeaderProps = {
  readonly label: string; // "Overview", "Frameworks"
  readonly title: string;
};

export function CihSectionHeader({ label, title }: CihSectionHeaderProps) {
  return (
    <div className="mx-auto max-w-7xl px-4 pt-14 pb-6 md:pt-20 md:pb-8 xl:px-0">
      <div className="text-xs font-medium tracking-[0.22em] text-gray-400 uppercase">
        {label}
      </div>
      <h2 className="mt-3 font-heading text-3xl font-medium tracking-tight text-gray-900">
        {title}
      </h2>
    </div>
  );
}
